import React from "react";
import { Trash2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export const BulkSelectionBar = ({
  visibleCount,
  selectedCount,
  allVisibleSelected,
  someVisibleSelected,
  onToggleAll,
  onClear,
  onDelete,
}) => (
  <div className="mt-4 pt-4 border-t border-[color:var(--vault-border)] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div className="flex items-center gap-3 min-w-0">
      <Checkbox
        id="select-all-visible"
        checked={allVisibleSelected ? true : someVisibleSelected ? "indeterminate" : false}
        onCheckedChange={onToggleAll}
        disabled={visibleCount === 0}
        aria-label="Select all visible vault items"
        data-testid="bulk-select-all-visible"
      />
      <label htmlFor="select-all-visible" className="text-sm cursor-pointer select-none">
        Select all visible <span className="text-[color:var(--vault-text-tertiary)]">({visibleCount})</span>
      </label>
      {selectedCount > 0 && (
        <span className="pill" data-testid="bulk-selection-count">{selectedCount} selected</span>
      )}
    </div>

    {selectedCount > 0 && (
      <div className="flex flex-wrap items-center gap-2">
        <Button type="button" variant="ghost" size="sm" onClick={onClear} data-testid="bulk-clear-selection-button">
          <X size={15} className="mr-1.5" /> Clear
        </Button>
        <Button
          type="button"
          size="sm"
          onClick={onDelete}
          className="bg-[color:var(--vault-error)] hover:bg-[#b91c1c] text-white"
          data-testid="bulk-delete-selected-button"
        >
          <Trash2 size={15} className="mr-1.5" /> Delete selected
        </Button>
      </div>
    )}
  </div>
);